class ReadMore extends HTMLElement {
  connectedCallback() {
    this.contentEl = this.querySelector('[data-read-more-content]');
    this.toggleEl  = this.querySelector('[data-read-more-toggle]');
    if (!this.contentEl || !this.toggleEl) return;

    this.toggleEl.addEventListener('click', () => this.toggle());

    // Decide whether the toggle is needed at all (content might be short enough to fit).
    this.evaluateOverflow();

    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(() => this.evaluateOverflow());
      this.resizeObserver.observe(this.contentEl);
    } else {
      window.addEventListener('resize', this.evaluateOverflow.bind(this), { passive: true });
    }
  }

  disconnectedCallback() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
  }

  evaluateOverflow() {
    // Temporarily uncollapse to measure full height vs collapsed height
    const wasExpanded = this.toggleEl.getAttribute('aria-expanded') === 'true';
    if (wasExpanded) return; // user already chose to expand — leave it alone

    this.contentEl.classList.add('read-more__content--collapsed');
    const collapsedHeight = this.contentEl.clientHeight;
    const fullHeight = this.contentEl.scrollHeight;

    if (fullHeight - collapsedHeight > 2) {
      this.toggleEl.hidden = false;
    } else {
      this.toggleEl.hidden = true;
      // Content fits — keep it uncollapsed so no clipped baseline shows
      this.contentEl.classList.remove('read-more__content--collapsed');
    }
  }

  toggle() {
    const expanded = this.toggleEl.getAttribute('aria-expanded') === 'true';
    const next = !expanded;
    this.toggleEl.setAttribute('aria-expanded', next ? 'true' : 'false');
    this.contentEl.classList.toggle('read-more__content--collapsed', !next);

    if (!next) {
      // Scroll back to the top of the read-more block when collapsing,
      // so the user doesn't end up below the section.
      const top = this.getBoundingClientRect().top + window.scrollY;
      if (window.scrollY > top) {
        window.scrollTo({ top: top - 24, behavior: 'smooth' });
      }
    }
  }
}

if (!customElements.get('read-more')) {
  customElements.define('read-more', ReadMore);
}
